/**
 * @generated SignedSource<<5b7a326e2aa8914aba393ceb50fd34f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CustomRulesFragment$data = {
  readonly customRules: ReadonlyArray<string>;
  readonly " $fragmentType": "CustomRulesFragment";
};
export type CustomRulesFragment$key = {
  readonly " $data"?: CustomRulesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CustomRulesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CustomRulesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customRules",
      "storageKey": null
    }
  ],
  "type": "LiquidDelegationRules",
  "abstractKey": null
};

(node as any).hash = "3f337276bd16886a3e2a08a24575601e";

export default node;
